function extractVueFunctions () {
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"frontmatter-markdown"},[_c('h2',[_c('strong',[_vm._v("Where do you meet your clients?")])]),_vm._v(" "),_c('p',[_vm._v("Our experience shows user conversion takes time and making sure people come back to your website multiple times, from multiple channels. With WhiteBox you could improve your sales funnel by essentially recording each step of each user journey, resulting optimization on advertising channels and improved storytelling.")])])}]

return { render, staticRenderFns }
}
const vueFunctions = extractVueFunctions()

module.exports = { 
      attributes: {"href":"/use-cases","summary":"Where did the conversions come from?"},
    
      vue: {
        component: {
          data: function () {
            return {
              templateRender: null
            }
          },
          render: function (createElement) {
            return this.templateRender ? this.templateRender() : createElement("div", "Rendering");
          },
          created: function () {
            this.templateRender = vueFunctions.render;
            this.$options.staticRenderFns = vueFunctions.staticRenderFns;
          }
        }
      },
     }